import { createFlowCard } from "@deliverr/ui-facility/lib-facility/flow/createFlowCard";
import { ScanFlowCardType } from "crossdock/common/flow/ScanFlowCardType";
import { ReviewSkusCardProps } from "@deliverr/ui-facility";

export const createOpenCaseCard = createFlowCard<Record<string, any>>(ScanFlowCardType.MISSING_LABEL_OPEN_CASE);
export const createScanPoCard = createFlowCard<Record<string, any>>(ScanFlowCardType.MISSING_LABEL_SCAN_PO);
export const createScanTrackingCard = createFlowCard<Record<string, any>>(ScanFlowCardType.MISSING_LABEL_SCAN_TRACKING);
export const createReviewSkusCard = createFlowCard<ReviewSkusCardProps>(ScanFlowCardType.MISSING_LABEL_REVIEW_SKUS);
export const createBoxContentsCard = createFlowCard<Record<string, any>>(ScanFlowCardType.MISSING_LABEL_BOX_CONTENTS);
